import { render } from "./ProductCard.vue?vue&type=template&id=6f03cd94&scoped=true"
import script from "./ProductCard.vue?vue&type=script&lang=js"
export * from "./ProductCard.vue?vue&type=script&lang=js"

import "./ProductCard.vue?vue&type=style&index=0&id=6f03cd94&lang=scss&scoped=true"
import "./ProductCard.vue?vue&type=style&index=1&id=6f03cd94&lang=scss"

import exportComponent from "/Users/flegate/Serveur/Sites/welcom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f03cd94"]])

export default __exports__